var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternshipIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.018,235.16L416,290.386h0.023c0.246,10.012,9.961,18.068,21.932,18.068c11.97,0,21.684-8.057,21.931-18.068h0.023 l-0.018-55.226c-0.189-10.055-9.93-18.16-21.936-18.16C425.947,217,416.205,225.105,416.018,235.16z",
    fill: "#ff4f31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.121,383.311c-2.225-3.689-7.02-4.876-10.708-2.651c-3.689,2.226-4.876,7.02-2.651,10.708 c5.526,9.161,18.18,15.081,32.238,15.081s26.712-5.92,32.238-15.081c2.225-3.689,1.037-8.482-2.651-10.708 c-3.691-2.224-8.482-1.037-10.708,2.651c-2.19,3.631-9.031,7.538-18.879,7.538C235.152,390.85,228.311,386.942,226.121,383.311z",
    fill: "#ff4f31"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.838,
    cy: 317.503,
    r: 15.703,
    fill: "#ff4f31"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.164,
    cy: 317.503,
    r: 15.703,
    fill: "#ff4f31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.797,448.204c-44.084,20.757-95.51,20.757-139.594,0c-12.429,10.218-22.57,23.112-29.56,37.796h198.713 C337.367,471.316,327.226,458.422,314.797,448.204z",
    fill: "#ff8b77"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M490,86.662c0-7.507-6.251-14.082-15.614-17.727L256.332,5.135C252.832,4.404,249.009,4,245,4 c-4.006,0-7.826,0.404-11.323,1.133L15.613,68.936C6.251,72.58,0,79.155,0,86.662c0,7.74,6.65,14.486,16.502,18.055 l216.354,63.297c3.718,0.84,7.823,1.311,12.145,1.311c4.325,0,8.436-0.471,12.155-1.313l216.337-63.293 C483.348,101.15,490,94.404,490,86.662z",
    fill: "#ff4f31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.954,138.88v59.224c3.244-0.724,6.598-1.104,10.001-1.104c3.402,0,6.756,0.379,9.999,1.104v-65.074L427.954,138.88z",
    fill: "#ff4f31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.953,340.27c3.672-12.928,5.637-26.574,5.637-40.68c0-19.264-3.666-37.67-10.338-54.562l6.748-1.962v-85.146v-7.936 l-127.228,37.223l-0.596,0.174l-0.605,0.138c-5.295,1.198-10.869,1.806-16.57,1.806c-5.689,0-11.258-0.606-16.552-1.803 l-0.609-0.137l-0.6-0.176L100,149.983v7.938v84.9l0.839,0.245l5.995,1.754c-6.725,16.948-10.424,35.427-10.424,54.77 c0,14.106,1.966,27.754,5.639,40.683c-8.741,28.741-25.318,54.853-48.148,75.08c38.053,20.88,81.235,25.254,120.74,15.14 c20.944,11.281,44.902,17.688,70.359,17.688s49.415-6.406,70.359-17.688c39.505,10.114,82.688,5.74,120.74-15.14 C413.268,395.125,396.693,369.012,387.953,340.27z M245,432.58c-73.447,0-132.99-59.542-132.99-132.99 c0-17.826,3.517-34.829,9.879-50.365l110.967,32.465c3.718,0.84,7.823,1.31,12.145,1.31c4.325,0,8.436-0.471,12.155-1.313 l111.031-32.279c6.315,15.486,9.804,32.426,9.804,50.182C377.99,373.038,318.447,432.58,245,432.58z",
    fill: "#ff8b77"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternshipIcons);
export default __webpack_public_path__ + "static/media/internship-icons.f3a824de1ff2986a8826cb52dea2a187.svg";
export { ForwardRef as ReactComponent };